/* Nutri Peak - sticky add-to-cart visibility controller.
   The theme's own StickyATC wiring relies on window scroll / IntersectionObserver,
   neither of which fires reliably: Lenis smooth-scroll transforms the page, and the
   subscription app block replaces the add-to-cart button after connectedCallback.
   This controller re-resolves the anchor on every check and is driven by a timer
   (not requestAnimationFrame, which is throttled to zero in background tabs). */
(function () {
  'use strict';

  var bar = null;
  var lastState = null;

  function findBar() {
    if (bar && bar.isConnected) return bar;
    bar = document.querySelector('sticky-atc');
    return bar;
  }

  function findAnchor() {
    return document.querySelector('.main_product_info .product_form_submit_button')
      || document.querySelector('.main_product_action_btns_wrapper')
      || document.querySelector('.product_form_submit_button');
  }

  function drawerOpen() {
    if (document.body.classList.contains('drawer_open')) return true;
    if (document.body.classList.contains('overflow_hidden')) return true;
    return !!document.querySelector('.drawer-wrapper.active, .drawer-wrapper.open, .drawer-wrapper.is-open, .cart_drawer.active');
  }

  function shouldShow() {
    var anchor = findAnchor();
    if (!anchor) return false;
    var r = anchor.getBoundingClientRect();
    if (!r.width && !r.height) return false;
    if (r.bottom > 0) return false;
    if (drawerOpen()) return false;

    var footer = document.querySelector('footer, .footer_wrapper, .main_footer, [id$="__footer"]');
    if (footer) {
      var f = footer.getBoundingClientRect();
      var vh = window.innerHeight || document.documentElement.clientHeight;
      if (f.top < vh - 40) return false;
    }
    return true;
  }

  function apply(show) {
    var el = findBar();
    if (!el) return;
    if (show === lastState) return;
    lastState = show;
    el.classList.toggle('is-visible', show);
    el.setAttribute('aria-hidden', show ? 'false' : 'true');
    if (show) {
      el.removeAttribute('inert');
    } else {
      el.setAttribute('inert', '');
    }
  }

  function check() {
    if (!findBar()) return;
    apply(shouldShow());
  }

  function start() {
    if (!document.querySelector('sticky-atc')) return;
    check();
    setInterval(check, 200);
    window.addEventListener('scroll', check, { passive: true });
    window.addEventListener('resize', check, { passive: true });
    if (window.lenis && typeof window.lenis.on === 'function') {
      window.lenis.on('scroll', check);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
